import React from "react";
import { Box } from "@chakra-ui/react";

const SalesJB = ({ content }) => {
  return <Box>{content}</Box>;
};

export default SalesJB;
